import troubles from "./bs_en_troubles";
export default [
  [
    {
      q: "Why can’t the Bluetooth find my vehicle?",
      a:
        "1. Please check whether the vehicle is started and is in P mode.<br/>\
        2. Please check whether the Bluetooth function of your mobile phone is turned on, or try to restart the phone's Bluetooth function.<br/>\
        (Due to the system bug of Android 10, users of Android 10 phones need to turn on the positioning function)<br/>\
        3. Please check whether the vehicle is in a pending linking state.<br/>\
        To ensure the safety of your vehicle, after the vehicle enters the pending linking state, if there is no operation, pushing or driving within 2 minutes, the vehicle will automatically exit the pending linking state, or the vehicle cannot be found by the Bluetooth handset. You can start the vehicle again and complete the activation process through search in the app within a given period."
    },
    {
      q:
        "Click to connect the vehicle found, but the app says connection failed?",
      a:
        "1. Please check whether the vehicle is in the binding state.<br/>\
        In order to ensure the safety of your vehicle, after the vehicle enters the binding state, if there is no operation, push or drive within 5 minutes, the vehicle will automatically exit the binding state, so the vehicle will not be able to connect.<br/>\
        You can complete the activation operation by restarting the vehicle and searching through the APP within a specific time.<br/>\
        2. It may be that the Bluetooth signal of your mobile phone is unstable, resulting in difficulty in connection. You can try to turn on and off the bluetooth function of the mobile phone and try to connect to the vehicle again."
    },
    {
      q:
        "How do I identify the target vehicle when multiple vehicles are found?",
      a:
        'You can determine which vehicle you want to bind by comparing the frame number information. The frame number is usually near the charging port in your vehicle seat, or where the VIN is printed, as shown below:\
      <div style="text-align:center;padding-top:24px;"><img src="/static/img/q3.png" width="180px" alt=""></div>'
    },
    {
      q: 'What to do if the app says “Activating vehicle network..."?',
      a:
        '1. Please check whether the network connection of your vehicle is normal.<br/>\
        You can check the network status on the vehicle screen. If you find that the vehicle is in a poor network, it is recommended that you move the vehicle to an open outdoor environment or an environment with a good network.<br/>\
        2. Please check whether the network connection of your mobile phone is normal.<br/>\
        The activation status may not be synchronized properly due to abnormal or unstable phone network.<br/>\
        3. Check whether the "notification permission" of your App is enabled. You can go to the phone Settings→Notifications→App→Open the notification permission; (the operation process may differ in different operation systems)<br/>\
        4. You can try to restart the App, or log out of the App login account and log in again to solve the problem.'
    },
    {
      q:
        "Is the Bluetooth connection process completed after successful activation and linking?",
      a:
        "After successful activation and linking, the mobile phone and the vehicle have only completed the connection of the BLE (Bluetooth Low Energy) module for the basic communication between the mobile phone and the vehicle.<br/>\
        If you need to use Bluetooth-related functions such as music or phone calls, please go to the phone Settings and connect the vehicle via your phone’s Bluetooth."
    },
    {
      q: "How do I unlink the vehicle?",
      a:
        "Log in to the app, select from the sidebar the vehicle you want to unlink, click Delete Vehicle, check the Delete Agreement, and click Delete to successfully unlink."
    },
    {
      q:
        "Why can’t the vehicle enter the pending activation state after unlinking from an account?",
      a:
        "After unbinding, if the vehicle cannot enter the pending binding state again, it may be because of the poor network connection of the current vehicle:<br/>\
        1. You can move the vehicle to an open environment where the network is good and then restart the vehicle to check the status;<br/>\
        2. Check whether the smart service of the vehicle has expired. If so, please renew the fee and then restart the vehicle to check the status.<br/>\
        * Some models can enter the vehicle setting function, find the 'Mode to be bound' mode, and actively set the vehicle to be bound state."
    }
  ],
  [
    {
      q: "How to update/unlink my phone number?",
      a:
        "To ensure the security of your account, you must link a mobile phone number after activating the vehicle. Therefore, the account which was used to activate the vehicle cannot be directly unbound. Updating the phone number is supported. <br/>\
        If you need to update your phone number, please go to the Settings page, enter the Account Security Center, manage the account linking, and click the phone number to change it."
    },
    {
      q: "Can I use the account on multiple handsets?",
      a:
        "Account login is not restricted to mobile devices. However, to protect account security and vehicle security, the same account cannot be used on multiple mobile devices at the same time. Otherwise, the account will be automatically logged out from other devices."
    },

    {
      q: "How to delete my account?",
      a:
        "The app supports account deletion. Before doing so, please make sure that there are no bound vehicles or unfinished or unpaid services under this account.<br/>\
        You can click Settings → Account Security → Delete Account to delete your account. Please be careful before deleting your account as the operation is irreversible. After deleting, you will not be able to log in or access any data relating to the Blueshark account."
    },
    {
      q: "How to manage the data permissions of my vehicle?",
      a:
        'We attach great importance to the protection of your privacy and personal information.<br/>\
        You can use App to realize but not limited to viewing vehicle conditions, positioning vehicles, positioning your location, vehicle dynamic record, remote control vehicles, setting vehicles and other functions.<br/>\
        In accordance with the principle of "minimization", we will directly or indirectly obtain your vehicle\'s location and driving path information, and do encryption processing.<br/>\
        You can access the Vehicle management page and select the Vehicle Data and Permission function to manage the permission. After a function is disabled, some functions may become unavailable.'
    }
  ],
  [
    {
      q: "What should I prepare before driving?",
      a:
        "To ensure your safety, please make the following preparations before driving:<br/>\
    1. Check whether the vehicle is normally powered on, and whether the lighting and other conditions are normal;<br/>\
    2. Check whether the front brake and the rear brake can work normally;<br/>\
    3. Check whether the tire pressure is normal;<br/>\
    4. Check whether the handlebars, the front wheels, and rear wheels are fixed, and whether the head lock is unlocked;<br/>\
    5. Make sure the remaining battery is sufficient;<br/>\
    6. Check whether there are any other fault alerts;<br/>\
    7. Wear a helmet and other protective gears."
    },
    {
      q: "How to start the vehicle?",
      a:
        'You can start the vehicle in a variety of ways:<br/>\
        1. Remote control key: (1) Click the unlock button on the remote control; (2) Take the remote control key with you. When you get close to the vehicle, the power button (such as the power button or the ready button) will blink regularly. Long press it to start the vehicle;<br/>\
        2.App: (1) Open the App and click "Start" to start the vehicle; (2)) The vehicle is bound to the mobile phone. When the vehicle is close to the vehicle, the power button (such as the power button or the ready button) will blink regularly. Long press it to start the vehicle;<br/>\
        3. Fingerprint unlock: Some models have fingerprint identification areas, so users can start the vehicle with their fingerprints without carrying keys or mobile phones.'
    },
    {
      q:
        "Why is there no power output when turning the handlebar, even though the vehicle is started?",
      a:
        'To protect your driving safety and avoid risky situations such as rushing-out, the vehicle uses sensors to ensure safe start. Before driving, you need to release the side kick-stand or the middle support and then sit on the vehicle.<br/>\
        Press the "READY" key on the right handlebar, and the "READY" indicator will light up, and the vehicle is ready for driving. Now, you can turn the handle to start driving.<br/>\
        The above functions are available only for some models, which can be switched on and off through the vehicle center of the mobile APP.'
    },
    {
      q: "What do I need to do after driving ended?",
      a:
        'When you reach your destination, press the "READY" button to cancel READY mode and lower the side brace or middle brace.<br/>\
        You can lock your vehicle in the following ways:<br/>\
        1. Remote control: Click the lock button on the remote control;<br/>\
        2. Mobile phone: Open the mobile App and click "Guard" to lock the vehicle;<br/>\
        3. Vehicle: According to the guidance of the vehicle manual, fortify through the physical buttons on the handlebars of the vehicle.<br/>\
        After the vehicle is locked, please turn the faucet to the left and check whether the faucet lock is locked.'
    }
  ],
  [
    {
      q: "What is the electronic side kickstand sensing function？",
      a:
        "To ensure your safety, the electronic side kickstand sensing function is used to detect the state of the side kickstand being lowered or released. When you are ready to drive, this function will remind you to release the side kickstand before starting to drive.<br/>\
        This function can be turned on or off through the vehicle OS or App Settings. It is recommended that novice users keep this function on."
    },
    {
      q: "What is the seat pressure sensing function?",
      a:
        "To ensure your safety, the seat pressure sensing function is used to detect whether a person is already sitting on the vehicle or not. When you are ready to drive, this function will remind you to sit firmly before starting to drive.<br/>\
        This function can be turned on or off through the vehicle OS or App Settings. It is recommended that novice users keep this function on."
    },

    {
      q: "What is the turn assist function?",
      a:
        "To ensure your safety, the turn assist function will activate the rear camera during your turn to present to you the road condition information behind, as a result compensating for blind spot.<br/>\
        (This function is only supported by some models)"
    },

    {
      q: "What is the reverse assist function?",
      a:
        "To ensure your safety, the reverse assist function will activate the rear camera and the rear ultrasonic radar during the reversing process to show you the obstacles behind the vehicle and the distance of those obstacles, as a result compensating for the blind spot.<br/>\
        (This function is only supported by some models)"
    }
  ],
  [
    {
      q: "How to pair with the mobile phone?",
      a:
        '1. After securely parking the vehicle, open the Smart Menu and select the Bluetooth Settings;<br/>\
    2. Select “Mobile phone" and turn on the Bluetooth, and click to pair with the mobile phone;<br/>\
    3. Turn to the phone’s Bluetooth page and make sure the mobile phone can be found;<br/>\
    4. On the vehicle, choose your mobile phone and pair with it;<br/>\
    5. The vehicle can remember previously connected mobile devices, so once connected devices are near, they can connect to the vehicle automatically. (Previously connected iOS devices can be connected again only when the phone’s Bluetooth is turned on while Android devices are not affected by this rule.)<br/>\
    6. To disconnect with a device, simply choose the corresponding device on the vehicle;<br/>\
    7. If the vehicle can’t detect your mobile phone, please make sure the Bluetooth function on your mobile phone is turned on and you’ve opened the Bluetooth page. If the vehicle still cannot find it, please turn off the Bluetooth and then turn it on again.'
    },

    // {
    //   q: "How to pair with a Bluetooth headset or a Bluetooth helmet?",
    //   a:
    //     '(Currently only available for the R1 models)<br/>\
    // 1. After securely parking the vehicle, open the Smart Menu and select the Bluetooth Settings;<br/>\
    // 2. Select "Headset/Helmet" and turn on the Bluetooth, and select the right device to connect;<br/>\
    // 3. Turn to your phone’s Bluetooth page and make sure the mobile phone can be found;<br/>\
    // 4. To disconnect with a device, simply choose the corresponding device on the vehicle;'
    // },
    {
      q: "How to enable the Bluetooth music function?",
      a:
        "1. Please make sure your mobile phone and your headset/helmet are connected to the vehicle. If not, the music will be played through the vehicle speaker;<br/>\
        2. After the mobile phone starts to play music,  you can play music right through the vehicle, no matter it is parked or on the road.<br/>\
        3. You can use the play/pause button on the vehicle to play and pause your music, press the OK button to play the next song, and click the volume Plus and Minus buttons to increase or lower the volume."
    }
    // {
    //   q: "How to enable the Bluetooth phone calls function?",
    //   a:
    //     '(Currently only available for the R1 models)<br/>\
    // 1. After securely parking the vehicle, open the Smart Menu and select the Bluetooth phone call function;<br/>\
    // 2. Please make sure your mobile phone and your headset/helmet are connected to the vehicle. The microphone on your handset/helmet will be used for the phone call.<br/>\
    // 3. Select "Sync Contacts" to synchronize the recent contacts and call history of your phone to the vehicle;<br/>\
    // 4. We provide you with three options which you can use to make outbound phone calls while in the parking state: "Recent Contacts", "All Calls" and “Missed Calls". Recent Contacts: 10 contacts who you recently had calls with. <br/>\
    // All Calls: up to 20 calls from the last 3 days;<br/>\
    // Missed Calls: up to 20 missed incoming calls;<br/>\
    // 5. If someone calls you, you can press the OK button on the vehicle to take the call, or use the "Back" button to hang up.'
    // }
  ],
  [
    {
      q: "Vehicle positioning",
      a:
        "The vehicle obtains the location through GPS signals. When a vehicle is indoors or in a closed area such as a basement, the accuracy of vehicle positioning will be affected. Moving the vehicle to an open environment and its GPS function will be normal again.<br/>\
        The driving route is formed by connecting the positioning points reported by the vehicle within a specified period of time. Due to positioning offset and signal occlusion, there might be incorrect positioning or even loss of positioning points, resulting in abnormal or inaccurate routes.<br/>\
        If you cannot locate the vehicle for a long time or if most of the driving routes are incorrect, please check whether the Smart Service of the vehicle has expired. If not, you can contact the service center to check the vehicle's network and GPS."
    },
    {
      q: "Push notifications",
      a:
        "You can troubleshoot according to the following instructions:<br/>\
        1. Please go to the Message Center on the upper right corner of the app homepage to confirm whether you can receive push messages like “vehicle vibration”;<br/>\
        2. Manage the Notification settings of your phone. Please go to the Settings page, select Notifications, select the app, and make sure Notifications are allowed.<br/>\
        3. Select the vehicle in the app, select the Vehicle Security mode, and check whether push notifications are allowed."
    },

    {
      q: "What is the Vehicle Security mode?",
      a:
        "To ensure the safety of your vehicle, notifications are pushed to alert you to abnormal events such as vehicle vibration, wheel movement, battery disconnection, battery over discharge, etc.<br/>\
        You can select the Alert mode or the Do-not-disturb mode according to the parking risk of the vehicle and customize your security settings.<br/>\
        If the vehicle moves, you can check the current location of the vehicle to make sure it’s secure."
    },

    {
      q: "Inaccurate estimated driving range on a charge",
      a:
        "The estimated driving range of the vehicle is calculated based on the user's driving habits and the corresponding power consumption history. The accuracy of estimated range is affected by various factors such as load conditions, road conditions, and the environment temperature. Generally, deviations between 20% are normal.<br/>\
        If the deviation is obviously too large or too small, it is usually not a problem with the battery, but due to data stability or data errors. If there are still large deviations after driving several times, please contact the after-sales service for further troubleshooting."
    },

    {
      q: "What should I do if the vehicle does not respond to remote control?",
      a:
        "Please check whether the network of your mobile phone is normal, and in the upper right corner of the app homepage, check whether the Bluetooth and network connection is normal. If either the internet or the Bluetooth is connected normally, the remote control command can be issued."
    }
  ],
  [
    {
      q: "What’s the purpose of vehicle upgrades?",
      a:
        "The main purpose of OTA upgrades is to improve user experience and optimize vehicle functions. Each time when an OTA upgrade is available, details of the upgrade will be alerted. Please refer to the page at the time of the upgrade for the details."
    },

    {
      q: "What are the requirements for vehicle upgrades?",
      a:
        "1. Please make sure that the vehicle is started and in the Parking state. And ensure that the remaining battery of the vehicle is over 20%. Do NOT remove the battery during the upgrade.<br/>\
        2. Please make sure your phone’s Bluetooth and cellular network are turned on. Get close to the vehicle, and keep the mobile phone and the vehicle connected."
    },

    {
      q: "What should I pay attention to during the upgrading process?",
      a:
        "1. During the upgrade, please do not drive the vehicle and ensure that it is turned on and not driving;<br/>\
        2. During the upgrade, please do not stay away from the vehicle and keep the vehicle and the mobile phone always connected;<br/>\
        3. After the upgrade starts, please do NOT remove the vehicle battery;<br/>\
        4. After the upgrade starts, please do NOT turn off the screen or the app, and keep the mobile phone's cellular network and Bluetooth on."
    },

    {
      q: "Why is the file transfer always interrupted?",
      a:
        "In the process of vehicle upgrade, the mobile phone is connected to the vehicle through WiFi network for file transmission. During the file transfer, the mobile phone is in no network state. After the file transfer is complete, the mobile phone network is restored.<br/>\
        Some IOS mobile phone users will remind the user that the current network status is not good, whether to disconnect or switch the network, please choose to continue using the current network;<br/>\
        For some Android mobile phone users, disable the Recent WLAN selection function because it automatically disconnects or switches the network. You can enable it after the file transfer is complete."
    },

    {
      q: "The upgrade is over, but I’m sure if it is successful.",
      a:
        "Please do not stay away from the vehicle during the upgrade and keep the Bluetooth connected.<br/>\
        During the vehicle upgrade process, the upgrade progress and status will be presented respectively in the vehicle engine system and App terminal.<br/>\
        If the connection is disconnected due to special circumstances, you can try to reconnect the vehicle. Or refresh the system upgrade page to view the current vehicle version. If the latest version is displayed, the upgrade succeeds. If some components are not the latest version, upgrade them again."
    }
  ],
  [
    {
      q: "How to charge the battery?",
      a:
        "The vehicle supports a variety of charging and replenishing modes:<br/>\
        1. Charger:<br/>\
        Please place the charging cradle on a flat surface and make sure the environment temperature is neither too high nor too low and the environment is not damp. Connect the direct charging charger to the power supply, then connect the charging base to the direct charging charger, and place the battery on the base correctly to start charging. When you need to charge two batteries at the same time, please connect the splitter to the charger and the two charging bases respectively.<br/>\
        The charging base needs to be used in conjunction with a direct charging charger.<br/>\
        2. Direct charging:<br/>\
        You can be charge the vehicle while the batteries are inside. Plug the power supply into the charging connector, and you can tell whether the battery is full through the screen.<br/>\
        3. BSS:<br/>\
        Part of the area covers the charging network of the BSS, which can be changed through the BSS by opening the swapping service."
    },

    {
      q: "What are the precautions during battery use?",
      a:
        "1. Battery operating environment:<br/>\
    -10~45℃;<br/>\
    Avoid being soaked by liquids;<br/>\
    Avoid foreign metal objects entering the battery compartment;<br/>\
    Avoid placing the battery near bright, flammable and explosive objects.<br/>\
    2. Battery capacity attenuation:<br/>\
    Under low temperature conditions, the usable capacity of the battery will attenuate to varying degrees. The reference value is:<br/>\
    When the temperature is -10 ℃, the usable capacity of the battery is about 70%;<br/>\
    0 ℃, about 85%;<br/>\
    25 ℃, about 100%;<br/>\
    3. Battery safety precautions:<br/>\
    If the battery is getting hot, getting deformed or producing odor, please stop using it immediately and stay away from the battery. Please contact the after-sales service center for inspection and repair. Please do not disassemble it by yourself. If the battery is disassembled without authorization, accidents such as fire and explosion may occur, and the warranty of the battery becomes invalid."
    },
    {
      q: "How to extend the battery life?",
      a:
        "The life of the battery is mainly determined by the number of charging cycles and the storage environment. A charging cycle refers to the process of fully discharging a 100% charged battery and then fully charging it again. Good usage habits, storage at 50% battery level in a dry environment with a temperature between 0°C and 25°C, and avoiding over-discharge, all can contribute to extending the battery life."
    }
  ],
  [
    {
      q: "Vehicle maintenance instructions",
      a:
        "1. Implementation of regular maintenance<br/>\
        Regular maintenance can effectively extend the service life of vehicles. The user can maintain the vehicle regularly according to the reminders of the vehicle system or App.<br/>\
        Without regular maintenance, the vehicle may have safety hazards, leading to malfunctions or accidents. During the maintenance process, if you find any abnormalities in the vehicle, please take the vehicle to a designated store or the service center for inspection and repair.<br/>\
        2. Methods of maintenance<br/>\
        The manual has introduced some main inspection items. For more thorough inspection, please go to the designated store or the service center, or implement maintenance according to the Blueshark after-sales service manual.<br/>\
        During regular maintenance, please be careful and adhere to the following advices:<br/>\
        Before performing regular maintenance, please choose an open and flat space, lower the middle support of the vehicle and then start to maintain the vehicle.<br/>\
        After a long-distance drive, some electronic components of the vehicle may become hot. Please do not disassemble any parts immediately in order to avoid damages.<br/>\
    During regular maintenance, if an abnormality is found in the vehicle, please make proper adjustments as soon as possible. If the abnormality cannot be handled by yourself, please go to the designated store or the service center for a complete inspection."
    }
  ],
  [
    {
      q: "The vehicle cannot be started",
      a:
        "Step 1:<br/>\
    Check whether the power switch is turned on, if not, please turn on the power switch of the vehicle;<br/>\
    Step 2:<br/>\
    Check whether the Remote Control has run out of battery. You can check whether the indicator light on the Remote Control key is off or flashing; if it’s off, please replace the battery for it;<br/>\
    Step 3:<br/>\
    Check whether the vehicle battery is inserted; if not, please insert a battery with sufficient power; if the battery is low, please charge it according to the instructions.<br/>\
    If you still cannot start the vehicle after trying the above methods, please contact the designated store or service center for inspection and repair."
    },

    {
      q: "Why does the driving distance become shorter after charging?",
      a:
        "Step 1:<br/>\
    Check if there is any tire damage or insufficient tire pressure. If so, please replace the tire or inflate the tire;<br/>\
    Step 2:<br/>\
    Check whether the environment temperature of the vehicle is too low as low driving environment temperature will affect the battery discharging efficiency, which is a normal phenomenon. Please make sure the charging environment is between 5℃ and 55℃;<br/>\
    Step 3:<br/>\
    Check whether the battery charging time is too short. Please make sure your charging method is correct the charging plug is correctly connected;<br/>\
    * After charging and discharging the battery many times, the total capacity of the battery can be attenuated to a degree, which is a normal phenomenon;<br/>\
    If the above conditions have been investigated and the problem still exists, please take the vehicle to the designated store or service center for inspection and repair."
    },

    {
      q: "The charger generates heat during charging",
      a:
        "Generally, the temperature of the charger will rise during the charging process, which is a normal phenomenon.<br/>\
    If the charger becomes too hot to be touched with your hands, please cut off the power immediately to stop charging, and send the charger to a designated store or service center for inspection and repair."
    },

    { q: "Error codes and troubleshooting advice", a: troubles }
  ]
];



// WEBPACK FOOTER //
// ./src/assets/js/helpMultilngual/bs_en_questions.js